import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'

import * as styles from './CalendarRailSource.module.css'

function CalendarRailSource({
  isChecked,
  source: { id, label, qaName, variant },
  onChange,
}) {
  const { t } = useTranslation()

  function handleChange(nextIsChecked) {
    onChange({ isChecked: nextIsChecked, source: id })
  }

  return (
    <Checkbox
      checked={isChecked}
      label={t(label)}
      labelTitleClassName={classNames(styles.title, styles[variant])}
      qaName={qaName}
      size={CHECKBOX_SIZE.small}
      type={CHECKBOX_TYPE.action}
      onChange={handleChange}
    />
  )
}

export default CalendarRailSource
